import React from "react";
import { Col } from "react-bootstrap";
import Person from "./Person";
import "./PeopleList.css";

function PeopleList({ people, language, role, resetUserPassword }) {
  return (
    <Col className="people-list">
      {people.map((element) => (
        <Person
          key={element._id}
          id={element._id}
          firstName={element.firstName}
          lastName={element.lastName}
          profileName={element.profileName}
          profileNameEnglish={element.profileNameEnglish}
          language={language}
          role={role}
          resetUserPassword={resetUserPassword}
        />
      ))}
    </Col>
  );
}

export default PeopleList;
